import React, { useState } from 'react';

const PricingPage = () => {
  const [isAnnual, setIsAnnual] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const prices = {
    monthly: {
      starter: 0,
      pro: 0,
      enterprise: 0
    },
    annual: {
      starter: 0,
      pro: 0,
      enterprise: 0
    }
  };

  const regularPrices = {
    monthly: {
      starter: 0,
      pro: 12,
      enterprise: 30
    },
    annual: {
      starter: 0,
      pro: 10,
      enterprise: 25
    }
  };

  const features = [
    { name: 'Max number of users', starter: '5', pro: '50', enterprise: 'Unlimited' },
    { name: 'Max projects (per year)', starter: '10', pro: '100', enterprise: 'Unlimited' },
    { name: 'Requirements management', starter: 'Basic', pro: 'Advanced*', enterprise: 'Advanced+' },
    { name: 'Integration requirements', starter: 'Basic', pro: 'Advanced*', enterprise: 'Advanced+' },
    { name: 'RAID Log Management', starter: true, pro: true, enterprise: true },
    { name: 'Approval management', starter: true, pro: true, enterprise: true },
    { name: 'Analytics & reporting', starter: true, pro: true, enterprise: true },
    { name: 'Product evaluation', starter: false, pro: true, enterprise: true },
    { name: 'Priority support', starter: false, pro: true, enterprise: true },
    { name: 'Jira Integration (coming soon)', starter: false, pro: true, enterprise: true },
    { name: 'Pre-loaded functional hierarchy', starter: false, pro: false, enterprise: true },
    { name: 'Pre-loaded requirements', starter: false, pro: false, enterprise: true },
    { name: 'AI requirements generation', starter: false, pro: false, enterprise: true },
    { name: 'Convert code to requirements', starter: false, pro: false, enterprise: true },
  ];

  const renderFeatureValue = (value) => {
    if (typeof value === 'boolean') {
      return (
        <span className={`feature-icon ${value ? 'feature-check' : 'feature-cross'}`}>
          {value ? '✓' : '✗'}
        </span>
      );
    }
    return <span className="feature-text">{value}</span>;
  };

  return (
    <div>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        body {
          font-family: 'Slack-Circular-Pro', 'Helvetica Neue', Helvetica, 'Segoe UI', Tahoma, Arial, sans-serif;
          line-height: 1.6;
          color: #1d1c1d;
          background: #ffffff;
        }
        /* Header */
        .header {
          position: fixed;
          top: 0;
          width: 100%;
          background: #fff;
          border-bottom: 1px solid #e8e8e8;
          z-index: 1000;
          padding: 16px 0;
        }
        .nav {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .logo {
          font-size: 22px;
          font-weight: 900;
          color: #ffa159;
          text-decoration: none;
        }
        .nav-menu {
          display: flex;
          list-style: none;
          gap: 32px;
        }
        .nav-menu a {
          text-decoration: none;
          color: #1d1c1d;
          font-weight: 400;
          font-size: 16px;
        }
        .nav-menu a:hover {
          color: #ffa159;
        }
        .hamburger {
          display: none;
          flex-direction: column;
          cursor: pointer;
          padding: 8px;
          z-index: 1001;
        }
        .hamburger span {
          width: 25px;
          height: 3px;
          background: #ffa159;
          margin: 3px 0;
          transition: all 0.3s ease;
          border-radius: 3px;
        }
        .hamburger.active span:nth-child(1) {
          transform: rotate(45deg) translate(8px, 8px);
        }
        .hamburger.active span:nth-child(2) {
          opacity: 0;
        }
        .hamburger.active span:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -7px);
        }
        .pricing-main-content {
          min-height: 100vh;
          background: #f8f8f8;
          margin-top: 72px;
        }
        .pricing-hero {
          padding: 80px 32px 10px;
          background: linear-gradient(135deg, #f4f4f4 0%, #ffffff 100%);
          text-align: center;
        }
        .pricing-hero h1 {
          font-size: 36px;
          font-weight: 700;
          color: #ffa159;
          margin-bottom: 16px;
          line-height: 1.25;
        }
        .pricing-hero p {
          font-size: 18px;
          color: #616061;
          max-width: 600px;
          margin: 0 auto 40px;
          line-height: 1.5;
        }
        .beta-announcement {
          background: linear-gradient(135deg, #ffa159, #FF4F00);
          color: white;
          padding: 16px 32px;
          border-radius: 12px;
          max-width: 700px;
          margin: 0 auto 10px;
          box-shadow: 0 4px 12px rgba(255, 161, 89, 0.3);
        }
        .beta-announcement h3 {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 8px;
        }
        .beta-announcement p {
          font-size: 16px;
          margin: 0;
          color: white;
        }
        /* Visual Pricing Table */
        .visual-pricing-section {
          padding: 20px 32px 20px;
          background: #f8f8f8;
        }
        .visual-pricing-container {
          max-width: 1400px;
          margin: 0 auto;
        }

        /* Desktop Table View */
        .desktop-pricing-table {
          display: grid;
          grid-template-columns: 250px repeat(3, 1fr);
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 32px rgba(0,0,0,0.12);
        }
        .desktop-pricing-table > * {
          border-bottom: 1px solid #e0e0e0;
        }
        .desktop-pricing-table > *:nth-last-child(-n+4) {
          border-bottom: none;
        }

        /* Mobile Card View */
        .mobile-pricing-cards {
          display: none;
        }

        /* Feature Labels Column */
        .feature-label-header {
          background: #f4f4f4;
          padding: 30px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-weight: 700;
          color: #1d1c1d;
          border-right: 1px solid #e0e0e0;
          border-bottom: 2px solid #e0e0e0;
        }
        .feature-label-item {
          background: #f4f4f4;
          padding: 20px 15px;
          font-size: 14px;
          font-weight: 500;
          color: #1d1c1d;
          border-right: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
        }
        .feature-label-cta {
          background: #f4f4f4;
          padding: 30px 20px;
          border-right: 1px solid #e0e0e0;
          border-bottom: none;
        }
        /* Plan Columns */
        .plan-header {
          padding: 30px 20px;
          border-bottom: 2px solid #e0e0e0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
        .plan-column-featured {
          background: linear-gradient(180deg, #fff5ed 0%, #ffffff 100%);
        }
        .plan-badge {
          padding: 12px 32px;
          border-radius: 50px;
          font-size: 18px;
          font-weight: 700;
          text-transform: uppercase;
          color: white;
          margin-bottom: 16px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        .badge-starter {
          background: linear-gradient(135deg, #5dccdc, #4db8c9);
        }
        .badge-pro {
          background: linear-gradient(135deg, #64b5f6, #42a5f5);
        }
        .badge-enterprise {
          background: linear-gradient(135deg, #9c4dcc, #8e24aa);
        }
        .plan-price {
          font-size: 40px;
          font-weight: 700;
          color: #1d1c1d;
          margin-bottom: 8px;
        }
        .plan-price-note {
          font-size: 12px;
          color: #616061;
        }
        .beta-price-tag {
          background: #FF4F00;
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
          margin-top: 8px;
          display: inline-block;
        }
        .regular-price-tag {
          font-size: 13px;
          color: #999;
          text-decoration: line-through;
          margin-top: 4px;
        }
        /* Feature Cells */
        .feature-cell {
          padding: 20px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
        .feature-icon {
          font-size: 24px;
          font-weight: 700;
        }
        .feature-check {
          color: #28a745;
        }
        .feature-cross {
          color: #ccc;
        }
        .feature-text {
          font-size: 13px;
          color: #616061;
          font-weight: 500;
        }
        /* CTA Buttons */
        .plan-cta {
          padding: 30px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: none;
        }
        .cta-button {
          width: 100%;
          padding: 14px 24px;
          border: none;
          border-radius: 50px;
          font-size: 16px;
          font-weight: 700;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          text-decoration: none;
          display: inline-block;
          text-align: center;
        }
        .cta-starter {
          background: linear-gradient(135deg, #5dccdc, #4db8c9);
          color: white;
        }
        .cta-starter:hover {
          background: linear-gradient(135deg, #4db8c9, #3da5b5);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        }
        .cta-pro {
          background: linear-gradient(135deg, #64b5f6, #42a5f5);
          color: white;
        }
        .cta-pro:hover {
          background: linear-gradient(135deg, #42a5f5, #2196F3);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        }
        .cta-enterprise {
          background: linear-gradient(135deg, #9c4dcc, #8e24aa);
          color: white;
        }
        .cta-enterprise:hover {
          background: linear-gradient(135deg, #8e24aa, #7b1fa2);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        }

        /* Mobile Plan Card Styles */
        .mobile-plan-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.1);
          margin-bottom: 24px;
          overflow: hidden;
        }
        .mobile-plan-card.featured {
          border: 2px solid #ffa159;
        }
        .mobile-plan-header {
          padding: 24px 20px;
          text-align: center;
          border-bottom: 2px solid #e0e0e0;
        }
        .mobile-plan-header.featured {
          background: linear-gradient(180deg, #fff5ed 0%, #ffffff 100%);
        }
        .mobile-feature-list {
          padding: 0;
        }
        .mobile-feature-item {
          padding: 14px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #f0f0f0;
        }
        .mobile-feature-item:last-child {
          border-bottom: none;
        }
        .mobile-feature-label {
          font-size: 13px;
          font-weight: 600;
          color: #1d1c1d;
          flex: 1;
          text-align: left;
        }
        .mobile-feature-value {
          flex-shrink: 0;
          margin-left: 12px;
        }
        .mobile-plan-cta {
          padding: 20px;
        }

        /* FAQ Section */
        .faq-section {
          padding: 20px 32px;
          background: #f8f8f8;
        }
        .faq-container {
          max-width: 800px;
          margin: 0 auto;
        }
        .faq-section h2 {
          font-size: 32px;
          font-weight: 700;
          color: #ffa159;
          text-align: center;
          margin-bottom: 24px;
        }
        .faq-item {
          margin-bottom: 24px;
          background: white;
          padding: 24px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }
        .faq-question {
          font-size: 18px;
          font-weight: 600;
          color: #1d1c1d;
          margin-bottom: 12px;
        }
        .faq-answer {
          font-size: 16px;
          color: #616061;
          line-height: 1.5;
        }
        /* Responsive */
        @media (max-width: 1200px) {
          .desktop-pricing-table {
            display: none;
          }
          .mobile-pricing-cards {
            display: block;
          }
          .visual-pricing-section {
            padding: 20px 16px;
          }
        }
        @media (max-width: 768px) {
          .hamburger {
            display: flex;
          }
          .nav-menu {
            position: fixed;
            top: 72px;
            left: 0;
            right: 0;
            background: white;
            flex-direction: column;
            padding: 20px 32px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            transform: translateY(-100%);
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
            gap: 16px;
          }
          .nav-menu.mobile-active {
            transform: translateY(0);
            opacity: 1;
            visibility: visible;
          }
          .pricing-hero h1 {
            font-size: 28px;
          }
          .beta-announcement {
            padding: 12px 20px;
          }
          .beta-announcement h3 {
            font-size: 18px;
          }
          .beta-announcement p {
            font-size: 14px;
          }
          .plan-badge {
            font-size: 16px;
            padding: 10px 24px;
          }
          .plan-price {
            font-size: 32px;
          }
        }
      `}</style>

      {/* Header */}
      <header className="header">
        <nav className="nav">
          <a href="/" className="logo">
            <img src="/logos/logo-reqsharp-light-orange.svg" alt="ReqSharp Logo" style={{height:'48px', verticalAlign:'middle'}} />
          </a>
          <button
            className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={`nav-menu ${mobileMenuOpen ? 'mobile-active' : ''}`}>
            <li><a href="/Pricing" onClick={() => setMobileMenuOpen(false)}>Pricing</a></li>
            <li><a href="#resources" tabIndex={-1} aria-disabled="true" style={{opacity: 0.5, cursor: 'not-allowed'}} title="Coming Soon..">Resources</a></li>
            <li><a href="#aboutus" tabIndex={-1} aria-disabled="true" style={{opacity: 0.5, cursor: 'not-allowed'}} title="Coming Soon..">About Us</a></li>
            <li><a href="/feedback" onClick={() => setMobileMenuOpen(false)}>Contact Us</a></li>
          </ul>
        </nav>
      </header>

      <main className="pricing-main-content">
        {/* Hero Section */}
        <section className="pricing-hero">
          <h1>Choose the Right Plan for Your Team</h1>
          <div className="beta-announcement">
            <h3>Limited Beta Access - Free for 6 Months!</h3>
            <p>Join our beta program and get full access to all features completely free. Help us shape the future of requirements management!</p>
          </div>
        </section>

        {/* Visual Pricing Table */}
        <section className="visual-pricing-section">
          <div className="visual-pricing-container">

            {/* Desktop Table View */}
            <div className="desktop-pricing-table">
              {/* Header Row */}
              <div className="feature-label-header">FEATURES</div>
              <div className="plan-header">
                <div className="plan-badge badge-starter">STARTER</div>
                <div className="plan-price">FREE</div>
                <div className="beta-price-tag">FREE DURING BETA AND BEYOND</div>
              </div>
              <div className="plan-header plan-column-featured">
                <div className="plan-badge badge-pro">PROFESSIONAL</div>
                <div className="plan-price">FREE NOW</div>
                <div className="beta-price-tag">FREE DURING 6-MONTH BETA</div>
                <div className="regular-price-tag">Then ${isAnnual ? regularPrices.annual.pro : regularPrices.monthly.pro}/user/mo</div>
              </div>
              <div className="plan-header">
                <div className="plan-badge badge-enterprise">ENTERPRISE</div>
                <div className="plan-price">POST-BETA</div>
                <div className="beta-price-tag">PLAN OFFERED AFTER THE 6-MONTH BETA</div>
                <div className="regular-price-tag">Then ${isAnnual ? regularPrices.annual.enterprise : regularPrices.monthly.enterprise}/user/mo</div>
              </div>

              {/* Feature Rows */}
              {features.map((feature, index) => (
                <React.Fragment key={index}>
                  <div className="feature-label-item">{feature.name}</div>
                  <div className="feature-cell">
                    {renderFeatureValue(feature.starter)}
                  </div>
                  <div className="feature-cell plan-column-featured">
                    {renderFeatureValue(feature.pro)}
                  </div>
                  <div className="feature-cell">
                    {renderFeatureValue(feature.enterprise)}
                  </div>
                </React.Fragment>
              ))}

              {/* CTA Row */}
              <div className="feature-label-cta"></div>
              <div className="plan-cta">
                <a href="https://www.reqsharp.com/LoginAndAuthentication" className="cta-button cta-starter">Join Starter</a>
              </div>
              <div className="plan-cta plan-column-featured">
                <a href="https://www.reqsharp.com/LoginAndAuthentication" className="cta-button cta-pro">Join Professional Beta</a>
              </div>
              <div className="plan-cta">
                <a href="https://www.reqsharp.com/feedback" className="cta-button cta-enterprise">Contact Sales</a>
              </div>
            </div>

            {/* Mobile Card View */}
            <div className="mobile-pricing-cards">
              {/* Starter Plan Card */}
              <div className="mobile-plan-card">
                <div className="mobile-plan-header">
                  <div className="plan-badge badge-starter">STARTER</div>
                  <div className="plan-price">FREE</div>
                  <div className="beta-price-tag">FREE DURING BETA AND BEYOND</div>
                </div>
                <div className="mobile-feature-list">
                  {features.map((feature, index) => (
                    <div key={index} className="mobile-feature-item">
                      <div className="mobile-feature-label">{feature.name}</div>
                      <div className="mobile-feature-value">
                        {renderFeatureValue(feature.starter)}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mobile-plan-cta">
                  <a href="https://www.reqsharp.com/LoginAndAuthentication" className="cta-button cta-starter">Join Starter</a>
                </div>
              </div>

              {/* Professional Plan Card */}
              <div className="mobile-plan-card featured">
                <div className="mobile-plan-header featured">
                  <div className="plan-badge badge-pro">PROFESSIONAL</div>
                  <div className="plan-price">FREE NOW</div>
                  <div className="beta-price-tag">FREE DURING 6-MONTH BETA</div>
                  <div className="regular-price-tag">Then ${isAnnual ? regularPrices.annual.pro : regularPrices.monthly.pro}/user/mo</div>
                </div>
                <div className="mobile-feature-list">
                  {features.map((feature, index) => (
                    <div key={index} className="mobile-feature-item">
                      <div className="mobile-feature-label">{feature.name}</div>
                      <div className="mobile-feature-value">
                        {renderFeatureValue(feature.pro)}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mobile-plan-cta">
                  <a href="https://www.reqsharp.com/LoginAndAuthentication" className="cta-button cta-pro">Join Professional Beta</a>
                </div>
              </div>

              {/* Enterprise Plan Card */}
              <div className="mobile-plan-card">
                <div className="mobile-plan-header">
                  <div className="plan-badge badge-enterprise">ENTERPRISE</div>
                  <div className="plan-price">POST-BETA</div>
                  <div className="beta-price-tag">PLAN OFFERED AFTER THE 6-MONTH BETA</div>
                  <div className="regular-price-tag">Then ${isAnnual ? regularPrices.annual.enterprise : regularPrices.monthly.enterprise}/user/mo</div>
                </div>
                <div className="mobile-feature-list">
                  {features.map((feature, index) => (
                    <div key={index} className="mobile-feature-item">
                      <div className="mobile-feature-label">{feature.name}</div>
                      <div className="mobile-feature-value">
                        {renderFeatureValue(feature.enterprise)}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mobile-plan-cta">
                  <a href="https://www.reqsharp.com/feedback" className="cta-button cta-enterprise">Contact Sales</a>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section">
          <div className="faq-container">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-item">
              <div className="faq-question">Will I notice any difference in features across the options during the beta period?</div>
              <div className="faq-answer">Between Starter and Professional options the features are same during the Beta period. The feature restriction will be enforced AFTER the beta.</div>
            </div>
            <div className="faq-item">
              <div className="faq-question">What is the difference between basic and advanced requirements management?</div>
              <div className="faq-answer">Some features like copy, manage links, audit log, etc are not available in the basic option</div>
            </div>
            <div className="faq-item">
              <div className="faq-question">Do I have to pay for any of the options during the beta period?</div>
              <div className="faq-answer">No. No payments needed during beta period</div>
            </div>
            <div className="faq-item">
              <div className="faq-question">Can I switch plans during or after the beta?</div>
              <div className="faq-answer">Yes! You can freely switch between plans anytime. Please contact us for this change.</div>
            </div>
            <div className="faq-item">
              <div className="faq-question">How can I contact you or provide feedback during beta?</div>
              <div className="faq-answer">
                We actively encourage beta participants to share feedback! You can submit suggestions, report issues, or request features directly through the platform, via email (<span style={{ fontWeight: 'bold', color: '#FF4F00' }}>info@reqsharp.com</span>), or through dedicated beta feedback channel (<a href="https://www.reqsharp.com/feedback" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold', color: '#FF4F00' }}>Submit feedback here</a>). Your input helps shape ReqSharp's development.
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PricingPage;